const filters = {
    spacesBeforeCaps: function(value) {
        return value.replace(/([A-Z])/g, ' $1').trim()
    },
}

export default filters
